import { Deal } from 'modules/domain/deal/types'
import { formatQuantity } from 'modules/utils/numbers/formatQuantity'

export const getDealPaidSum = (deal: Deal) => {
  return formatQuantity(deal.quantity_paid_for)
}
